import { useRef, useState } from "react";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import {
	ContactApiSearchSelect,
	OrderApi,
	OrderItemApi,
	ProductStateApi,
	PurchaseApi,
	PurchaseItemApi,
} from "../../../../../../../../src/services/Api/Organization/types";
import { api } from "../../../../../../../../src/services/Api/api";

export const useExternalProductsState = <T extends PurchaseApi | OrderApi | undefined>(resource: T) => {
	const [externalProductStates, setExternalProductStates] = useState<ProductStateApi[]>([]);
	const selectedContact = useRef<ContactApiSearchSelect | undefined>(undefined);
	const { addFlash } = useFlash();

	const getExternalStates = async (items: OrderItemApi[] | PurchaseItemApi[]) => {
		if (selectedContact?.current?.document_transfer || resource?.channel?.provider === "DOCUMENT_TRANSFER") {
			const contactId = selectedContact.current?.id ?? resource?.contact?.id;
			try {
				const watchedItemsIds = items.map((item) => item.product_id?.toString()).filter((itemId) => itemId);
				const uniqueWatchedItemsIds = Array.from(new Set(watchedItemsIds));
				const params = {
					contact_id: contactId,
					product_ids: uniqueWatchedItemsIds.join(","),
				};
				const res = await api.organization().getExternalProductState(params);
				setExternalProductStates(res);
			} catch (err) {
				handleError.alert(err, addFlash);
			}
		} else {
			setExternalProductStates([]);
		}
	};

	const getExternalStateName = (): string => {
		const { current: contact } = selectedContact;
		if (!contact?.label) return "";
		return contact.label.length > 6 ? `${contact.label.substring(0, 6)}.:` : `${contact.label}:`;
	};

	return {
		getExternalStates,
		externalProductStates,
		selectedContact,
		getExternalStateName,
	};
};
